module.exports = ["Hoe heter de soep, hoe langer de pauze.","Beter één soep in de hand, dan tien in de kast.","Investeer in pauze, want pauze werkt.","Stop, pauze-time!","Een dag niet gepauzeerd, is een dag niet geleefd.","Change zei Obama, dan doe ik er kaaskorstjes bij!","Tussen woord *sip*, en daad *sip*, staan vele pauzes.","Pauze. Met de P van Pakhetereensvan.","Stress? Schuldt het van u af met een Royco-zakje.","Genoeg gewerkt, nu is het tijd om uit te blazen.","Met jouw werk geraak je van punt A naar B. Met een pauze geraak je overal!","Verbeter de wereld, start met een Royco pauze."]


//////////////////
// WEBPACK FOOTER
// ./src/assets/roycuotes.json
// module id = tftt
// module chunks = 0